import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@talentech/components";

export interface ICustomerForm {
  firstName: string;
  lastName: string;
  email: string;
  company: string;
  promoCode: string;
}

export interface ICustomerResponse {
  id: string;
  customerName: string;
  shortName: string;
  tenantOwner: {
    id: string;
    email: string;
  };
  externalTenant: Array<{
    name: string;
    companyId: string;
    apiURL: string;
    apiKey: string;
    status: string;
  }>;
  productList: Array<{
    talentechProductId: string;
    status: string;
    createdDate: string;
    updatedDate: string;
  }>;
}

export interface ICustomerPayload {
  customerName: string;
  shortName: string;
  tenantAdminUser: Omit<ICustomerForm, "company" | "promoCode">;
  productList: { productId: string }[];
  promoCode: string;
  defaultCulture: string;
  defaultLanguage: string;
}

export const customerApi = createApi({
  reducerPath: "customerApi",
  baseQuery: axiosBaseQuery({ baseUrl: process.env.API_URL as string }),
  endpoints: (builder) => ({
    createCustomer: builder.mutation<ICustomerResponse, ICustomerPayload>({
      query: (data) => ({
        url: "/v1/webform/customer",
        method: "POST",
        data,
        headers: {
          "X-API-KEY": `${process.env.API_KEY}`,
        },
      }),
    }),
  }),
});

export const { useCreateCustomerMutation } = customerApi;
